import { AccountLoginModal } from 'components/AccountLoginModal';
import { CreateAccountWithPasswordModal } from 'components/CreateAccountWithPasswordModal';
import { useAppSelector } from 'hooks/redux';
import { useIsNewDesign } from 'hooks/useIsNewDesign';
import { CreateAccountEmailModal } from 'modules/ScrShopNew/components/CreateAccountWithPasswordModal';
import { ForgotPasswordModal } from 'modules/ScrShopNew/components/ForgotPasswordModal';
import { LoginWithPasswordAccountModal } from 'modules/ScrShopNew/components/LoginWithPasswordAccountModal';
import { ShopOtpLoginModal } from 'modules/ScrShopNew/components/OtpLoginModal';
import { CreateAccountEmailModal as OldCreateAccountEmailModal } from 'modules/ScrShop/components/CreateAccountWithPasswordModal';
import OldForgotPasswordModal from 'modules/ScrShop/components/ForgotPasswordModal';
import OldLoginWithPasswordAccountModal from 'modules/ScrShop/components/LoginWithPasswordAccountModal';

// Legacy-design login / registration modals (moved out of App.tsx unchanged). The new-design set
// is modules/ScrAppBookNew/components/modals/auth/NewAuthModals.
// The new design renders these on the shop and photobook pages too; there, with the new shop,
// sign-in and sign-up are the one-time-code flow in the shop's look. The old design is unchanged.
export const LegacyAuthModals: React.FC = () => {
  const isNewDesign = useIsNewDesign();
  const newShop = useAppSelector(
    (state) => (state.collection.collectionCreator as any)?.featureFlags?.newShop === true
  );

  const renderShopModals = () => {
    if (!newShop) {
      return (
        <>
          <OldForgotPasswordModal />
          <OldLoginWithPasswordAccountModal />
          <OldCreateAccountEmailModal />
        </>
      );
    }

    if (isNewDesign) return <ShopOtpLoginModal />;

    return (
      <>
        <ForgotPasswordModal />
        <LoginWithPasswordAccountModal />
        <CreateAccountEmailModal />
      </>
    );
  };

  return (
    <>
      <CreateAccountWithPasswordModal />
      <AccountLoginModal />
      {renderShopModals()}
    </>
  );
};
